import { read, utils, writeFile } from "xlsx";

const ReadExcelFile = (file, onReadCallback) => {
  if (file) {
    const reader = new FileReader();

    reader.onload = (event) => {
      const data = event.target.result;
      const workbook = read(data, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      const excelData = utils.sheet_to_json(worksheet, { header: 1 });
      onReadCallback(excelData);
    };

    reader.readAsBinaryString(file);
  }
};

const readExcelFileNew = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const data = e.target.result;
      const workbook = read(data, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const jsonData = utils.sheet_to_json(sheet);
      resolve(jsonData);
    };
    reader.onerror = (error) => {
      reject(error);
    };
    reader.readAsBinaryString(file);
  });
};

const ExportExcelFile = ({ data = [], columns = [], filename = "" }) => {
  const worksheet = utils.json_to_sheet(data, {
    origin: "A2",
    skipHeader: true
  });
  columns.forEach(({ name }, index) => {
    worksheet[utils.encode_col(index) + 1] = { v: name, t: "s" };
  });
  const workbook = utils.book_new();
  utils.book_append_sheet(workbook, worksheet, "Sheet1");

  writeFile(workbook, `${filename}.xlsx`);
};

export { ReadExcelFile, readExcelFileNew, ExportExcelFile };
